import { gameweekEntitySchema } from '@crowdfpl/domain/gameweek';
import { simpleOffsetPaginationSchema } from '@crowdfpl/domain/pagination';
import { z } from 'zod';

export const GameweekSchema = gameweekEntitySchema;

export const GameweeksListResponseSchema = z.object({
  gameweeks: z.array(GameweekSchema),
  pagination: simpleOffsetPaginationSchema,
});

export type GameweekDto = z.infer<typeof GameweekSchema>;
export type GameweeksListResponse = z.infer<typeof GameweeksListResponseSchema>;
